import { FilterType } from "@studyportals/omnisearch-interfaces";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { EducationalFormFilterValue } from "@studyportals/search-api-interface";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";
import { PortalType } from "@studyportals/domain-client";
import { IExtendedFilterValue } from "@app/interfaces/dtos/IExtendedFilterValue";

export class EducationalFormFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.EDUCATIONAL_FORM;
	public isMultiSelect = true;
	private static instance: EducationalFormFilterMapper;

	public override getAllExtendedFilterValues(portalType?: PortalType): IExtendedFilterValue[] {
		if (portalType === PortalType.SHORT) return this.values;
		return [];
	}

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{ id: EducationalFormFilterValue.ACADEMIC_COURSE, virtualPath: 'academic-course', name: 'Academic Course' },
		{ id: EducationalFormFilterValue.CONFERENCE_SEMINAR, virtualPath: 'conference', name: 'Conference/Seminar', isNotIndexable: true },
		{ id: EducationalFormFilterValue.SUMMER_SCHOOL, virtualPath: 'summer-school', name: 'Summer School', },
		{ id: EducationalFormFilterValue.WINTER_SCHOOL, virtualPath: 'winter-school', name: 'Winter School' , isNotIndexable: true },
		{ id: EducationalFormFilterValue.SEMESTER_STUDY_ABROAD, virtualPath: 'semester-abroad', name: 'Semester/Study Abroad' },
		{ id: EducationalFormFilterValue.SKILL_PROFESSIONAL_COURSE, virtualPath: 'skill', name: 'Skill/Professional Course' },
	];

	public static getInstance(): EducationalFormFilterMapper {
		if (!EducationalFormFilterMapper.instance) {
			EducationalFormFilterMapper.instance = new EducationalFormFilterMapper();
		}
		return EducationalFormFilterMapper.instance;
	}

	private constructor() {
		super();
	}
}
